import React from 'react';

const HERO_WEBP = `${process.env.PUBLIC_URL}/assets/home_burger_3.webp`;
const HERO_JPG = `${process.env.PUBLIC_URL}/assets/home_burger_3.jpg`;

type HeroBackgroundProps = {
  className?: string;
  children: React.ReactNode;
  priority?: boolean;
  /** Latest-deal artwork overlaid on desktop; stacked under copy on mobile. */
  imageUrl?: string | null;
};

export function HeroBackground({
  className = '',
  children,
  priority = false,
  imageUrl = null,
}: HeroBackgroundProps) {
  const dealSrc = imageUrl?.trim() || null;
  const imgPriorityProps = priority ? { fetchPriority: 'high' as const } : {};

  return (
    <div
      className={`chunkzters-hero-media d-flex align-items-center justify-content-center ${
        dealSrc ? 'chunkzters-hero-media--withDeal' : ''
      } ${className}`.trim()}
    >
      <picture className="chunkzters-hero-picture">
        <source srcSet={HERO_WEBP} type="image/webp" />
        <img
          src={HERO_JPG}
          alt=""
          className="chunkzters-hero-image"
          decoding="async"
          {...imgPriorityProps}
        />
      </picture>
      <div className="chunkzters-hero-content">{children}</div>
      {dealSrc ? (
        <img src={dealSrc} alt="Latest deal" className="chunkzters-hero-deal" decoding="async" />
      ) : null}
    </div>
  );
}
